import { useTranslation } from 'react-i18next';
import type { IDeliveryCalendarAssortmentDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';

interface IDeliveryDaysLegendProps {
  assortments: IDeliveryCalendarAssortmentDtoData[];
  isReadonly: boolean;
}

const DeliveryDaysLegend = ({ assortments, isReadonly }: IDeliveryDaysLegendProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 h-full">
      {/* Legende Header */}
      <div className="mb-4">
        <h6 className="text-lg font-semibold">{t('Legende')}</h6>
      </div>

      {/* Aktueller Tag */}
      <div className="flex items-center">
        <div className="w-8 aspect-square border-4 border-secondary opacity-70 mr-4" />
        <p className="text-sm text-gray-600">{t('Aktueller Tag')}</p>
      </div>

      {/* Nächstmöglicher Liefertag */}
      <div className="flex items-center">
        <div className="w-8 aspect-square border-4 border-primary mr-4" />
        <p className="text-sm text-gray-600">{t('Nächstmöglicher Liefertag')}</p>
      </div>

      {/* Selektierter Liefertag (nur wenn nicht Readonly) */}
      {!isReadonly && (
        <div className="flex items-center">
          <div className="w-8 aspect-square border-4 border-primary bg-primary mr-4" />
          <p className="text-sm text-gray-600">{t('Selektierter Liefertag')}</p>
        </div>
      )}

      {/* Dynamische Einträge aus `deliveryAssortments` */}
      {assortments.map(entry => (
        <div className="flex items-center" key={entry.name}>
          <div
            className="w-8 aspect-square mr-4"
            style={{
              backgroundColor: `rgb(${entry.rcolor}, ${entry.gcolor}, ${entry.bcolor})`
            }}
          />
          <p className="text-sm text-gray-600">{t(entry.name as any)}</p>
        </div>
      ))}
    </div>
  );
};

export default DeliveryDaysLegend;
